module.exports = require("./../../_gen/starling/utils/StringUtil");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/StringUtil.js
// module id = 254
// module chunks = 0